import { Box, Card, Grid, Typography } from "@mui/material";
import styles from "../Information/Information.module.scss";

const EventFacilities = () => {
  const rentalFacilitiesList = [
    // {
    //     id: 1,
    //     facilityname: "New Neivedyam Kitchen",
    //     image: "/images/srimantas.png"
    // },
    // {
    //     id: 2,
    //     facilityname: "Relocated and Expanded main Kitchen",
    //     image: "/images/srimantas.png"
    // },
    // {
    //     id: 3,
    //     facilityname: "Three New Event Halls",
    //     image: "/images/srimantas.png"
    // },
    // {
    //     id: 4,
    //     facilityname: "Three New event Rooms",
    //     image: "/images/srimantas.png",
    // },
    {
      id: 5,
      facilityname: "Hindu Heritage Hall & children library",
      image: "/images/srimantas.png",
    },
    {
      id: 6,
      facilityname: "Medical Health Advisory Facility",
      image: "/images/srimantas.png",
    },
    {
      id: 7,
      facilityname: "Facility for nursing Babies",
      image: "/images/srimantas.png",
    },
    // {
    //     id: 8,
    //     facilityname: "A puja room with homakunda",
    //     image: "/images/srimantas.png"
    // }
  ];

  const rentalFacilities = [
    {
      id: 3,
      image: "/images/srimantas.png",
      facilitieName: "Akella Assembly Hall Reservations",
      size: "50’ x 70’ = 3500 SFT",
      capacity: "360 Lecture and 240 Banquet",
    },
    {
      id: 8,
      image: "/images/srimantas.png",
      facilitieName: "Lakireddy Auditorium",
      size: "60’ x 70’ = 4200 SFT",
      capacity: "500 Lecture and 240 Banquet",
    },
    {
      id: 17,
      image: "/images/srimantas.png",
      facilitieName: "Badrinath East Building-D With Homa Kunda",
      size: "30’ x 24’ = 720 SFT",
      capacity: "60 Lecture and 40 Banquet",
    },
    {
      id: 18,
      image: "/images/srimantas.png",
      facilitieName: "Badrinath West Building-D",
      size: "40’ x 24’ = 960 SFT",
      capacity: "60 Lecture and 48 Banquet",
    },
    {
      id: 2,
      image: "/images/srimantas.png",
      facilitieName: "Chamundi Hall",
      size: "14’ x 16’ = 224 SFT",
      capacity: "20 Lecture and 0 Banquet",
    },
    {
      id: 14,
      image: "/images/srimantas.png",
      facilitieName: "Gangotri Building-D",
      size: "26’ x 27’ = 702 SFT",
      capacity: "50 Lecture and 40 Banquet",
    },
    {
      id: 15,
      image: "/images/srimantas.png",
      facilitieName: "Kedarnath East Building-D",
      size: "26’ x 24’ = 624 SFT",
      capacity: "50 Lecture and 40 Banquet",
    },
    {
      id: 15,
      image: "/images/srimantas.png",
      facilitieName: "Kedarnath West Building-D",
      size: "26’ x 24’ = 624 SFT",
      capacity: "50 Lecture and 40 Banquet",
    },
    {
      id: 12,
      image: "/images/srimantas.png",
      facilitieName: "Meeting Room",
      size: "600 SFT",
      capacity: "40 Lecture and 0 Banquet",
    },
    {
      id: 10,
      image: "/images/srimantas.png",
      facilitieName: "Palani Building-C",
      size: "19’ x 25’ = 475 SFT",
      capacity: "40 Lecture and 32 Banquet",
    },
    {
      id: 20,
      image: "/images/srimantas.png",
      facilitieName: "Sabarimala Building-D",
      size: "15’ x 12’ = 180 SFT",
      capacity: "4 Lecture and 0 Banquet",
    },
    {
      id: 11,
      image: "/images/srimantas.png",
      facilitieName: "Tirumala Building-C",
      size: "50’ x 27’ = 1350 SFT",
      capacity: "120 Lecture and 96 Banquet",
    },
    {
      id: 19,
      image: "/images/srimantas.png",
      facilitieName: "Yamunotri Building-D",
      size: "15’ x 12’ = 180 SFT",
      capacity: "4 Lecture and 0 Banquet",
    },
    // {
    //     id: 1,
    //     image: "/images/srimantas.png",
    //     facilitieName: "Temple Homa Gunda",
    //     size: "1420sq ft",
    //     capacity: "100 people",
    // },
    // {
    //     id: 4,
    //     image: "/images/srimantas.png",
    //     facilitieName: "Event Room 1",
    //     size: "500sq ft",
    //     capacity: "50 people",
    // },
    // {
    //     id: 5,
    //     image: "/images/srimantas.png",
    //     facilitieName: "Event Room 2",
    //     size: "714sq ft",
    //     capacity: "50 people",
    // },
    // {
    //     id: 6,
    //     image: "/images/srimantas.png",
    //     facilitieName: "Event Room 3",
    //     size: "213sq ft",
    //     capacity: "15 people",
    // },
    // {
    //     id: 7,
    //     image: "/images/srimantas.png",
    //     facilitieName: "Akella Annadana Kitchen Building",
    //     size: "4347sq ft",
    //     capacity: "400 people",
    // },
    // {
    //     id: 9,
    //     image: "/images/srimantas.png",
    //     facilitieName: "Lakkireddy Auditorium",
    //     size: "4347sq ft",
    //     capacity: "400 people",
    // },
    // {
    //     id: 13,
    //     image: "/images/srimantas.png",
    //     facilitieName: "Z. Board Room",
    //     size: "4347sq ft",
    //     capacity: "400 people",
    // },
  ];

  // Sort rentalFacilities alphabetically by facilitieName
  rentalFacilities.sort((a, b) =>
    a.facilitieName.localeCompare(b.facilitieName)
  );

  rentalFacilitiesList.sort((a, b) =>
    a.facilityname.localeCompare(b.facilityname)
  );

  return (
    <>
      <div className={styles.EventFacilitiesLayout}>
        <Grid>
          <Typography className={styles.typoGraphyHeading}>
            Event Facilities
          </Typography>
          <Card className={styles.cardContainer}>
            <Grid className={styles.imageMainContainer}>
              <div className={styles.imagecontainer}>
                <img src="/images/lakkireddyauditorium.png" />
                <Typography className={styles.headertypo}>
                  Lakireddy Auditorium
                </Typography>
              </div>

              <div className={styles.imagecontainer}>
                <img src="/images/Assembly_hall.png" />
                <Typography className={styles.headertypo}>
                  Akella Assembly Hall
                </Typography>
              </div>
              <div className={styles.imagecontainer}>
                <img src="/images/badrinatheventhall.png" />
                <Typography className={styles.headertypo}>
                  Badrinath Event Hall
                </Typography>
              </div>
              <div className={styles.imagecontainerMap}>
                <div className={styles.buldingsmap}>
                  <img src="/images/buildingsmap.png" />
                </div>
              </div>
            </Grid>
            <Grid sx={{ marginTop: "20px" }}>
              <Typography className={styles.typoGraphyHeadingColor}>
                Expanded Facilities
              </Typography>
            </Grid>
            <Grid>
              <div style={{ width: "100%" }}>
                {rentalFacilitiesList.map((facility, id) => (
                  <div key={facility.id} style={{ display: "inline-block" }}>
                    <div className={styles.container} style={{width: "390px"}}>
                    <Box sx={{ display: "flex", alignItems: "center", pr: "10px" }}>
                        <div className={styles.circleImage}>
                          <img
                            src={facility.image}
                            alt={facility.facilityname}
                          />
                        </div>
                        <div className={styles.facilitieNameDiv}>
                          <Typography
                            className={styles.facilitieName}
                            title={facility.facilityname}
                          >
                            {facility.facilityname}
                          </Typography>
                        </div>
                      </Box>
                    </div>
                  </div>
                ))}
              </div>
            </Grid>
            <div>
              <Grid sx={{ marginTop: "30px" }}>
                <Typography className={styles.typoGraphyHeadingColor}>
                  Rental Facilities
                </Typography>
              </Grid>
              {rentalFacilities.map((rentalfacilitie, id) => (
                <div
                  key={rentalfacilitie.id}
                  style={{ display: "inline-block" }}
                >
                  <div className={styles.rentalContainer}>
                    <Box sx={{ display: "flex", pr: "10px" }}>
                      <div className={styles.circleImage}>
                        <img
                          src={rentalfacilitie.image}
                          alt={rentalfacilitie.facilitieName}
                        />
                      </div>
                      <Box sx={{ width: "100%" }}>
                        <Typography className={styles.facilitieName}>
                          {rentalfacilitie.facilitieName}
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "wrap",
                          }}
                        >
                          <Typography className={styles.facilitiesize}>
                            Size
                          </Typography>
                          <Typography className={styles.facilitiesize}>
                            {rentalfacilitie.size}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "wrap",
                          }}
                        >
                          <Typography className={styles.facilitiesize}>
                            Capacity
                          </Typography>
                          <Typography className={styles.facilitiesize}>
                            {rentalfacilitie.capacity}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </div>
                </div>
              ))}
            </div>
            <Grid sx={{ marginTop: "30px" }}>
              <Typography className={styles.typoGraphyHeadingColor}>
                Some of the Events you may host at HCCC Event Facilities
              </Typography>

              <div className={styles.containersList}>
                <img src="/images/wedding.png" className={styles.imagelist} />
                <Typography className={styles.header}>Wedding</Typography>
              </div>
              <div className={styles.containersList}>
                <img
                  src="/images/upanyasevent.png"
                  className={styles.imagelist}
                />
                <Typography className={styles.header}>Upanyanams</Typography>
              </div>
              <div className={styles.containersList}>
                <img
                  src="/images/srimantamsevent.png"
                  className={styles.imagelist}
                />
                <Typography className={styles.header}>Srimantams</Typography>
              </div>
              <div className={styles.containersList}>
                <img
                  src="/images/birthdaypartys.png"
                  className={styles.imagelist}
                />
                <Typography className={styles.header}>
                  Birthday Parties
                </Typography>
              </div>
              <div className={styles.containersList}>
                <img
                  src="/images/shastipurtievent.png"
                  className={styles.imagelist}
                />
                <Typography className={styles.header}>Shastipurti</Typography>
              </div>
              <div className={styles.containersList}>
                <img
                  src="/images/ayushhomam.png"
                  className={styles.imagelist}
                />
                <Typography className={styles.header}>Ayush Homan</Typography>
              </div>
            </Grid>
            <Grid sx={{ marginTop: "20px" }}>
              <Typography className={styles.typoGraphyHeadingColor}>
                Amenities
              </Typography>
              <div className={styles.amenitiescard}>
                <Typography className={styles.headerlists}>Chairs</Typography>
                <Typography className={styles.headerlists}>
                  Round Tables
                </Typography>
                <Typography className={styles.headerlists}>
                  Sound system
                </Typography>
                <Typography className={styles.headerlists}>Stage</Typography>
              </div>
            </Grid>
          </Card>
        </Grid>
      </div>
    </>
  );
};
export default EventFacilities;
